import type { SearchQuizsetRes } from '@/api/gen/_model/searchQuizsetRes';
import type { QuizListItemProps } from '@/shared/quizList/hooks';
import { QuizListItem } from '@/shared/quizList/QuizListItem';
import { FolderCard } from '../../quiz-folder';
import type { LibraryItem } from '../types/library.types';
interface LibraryListItemProps {
  item: LibraryItem;
  /**
   * 퀴즈 행에만 호출된다. 콜백으로 받는 이유는 폴더 행을 그릴 때 퀴즈 전용 값(과목명·메뉴)을
   * 만들 필요도, 빈 값을 지어낼 필요도 없게 하기 위해서다.
   */
  quizProps: (quiz: SearchQuizsetRes) => Omit<QuizListItemProps, 'quizSet'>;
}

/**
 * 자료실 한 줄. **콘텐츠 종류에 따른 분기는 여기서 끝난다.**
 *
 * 퀴즈는 기존 `QuizListItem` 을 손대지 않고 그대로 쓰고, 폴더는 `FolderCard` 를 링크 모드로
 * 쓴다. 두 컴포넌트가 같은 행 지오메트리를 공유하므로 섞여도 정렬선이 맞는다.
 */
export const LibraryListItem = ({
  item,
  quizProps
}: LibraryListItemProps) => {
  if (item.kind === 'FOLDER') {
    return <FolderCard showAuthor folder={item.folder} href={`/folder/${item.id}`} />;
  }
  return <QuizListItem {...quizProps(item.quiz)} quizSet={item.quiz} data-sentry-element="QuizListItem" data-sentry-component="LibraryListItem" data-sentry-source-file="LibraryListItem.tsx" />;
};